import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { useBreakpoints } from 'hooks/useMediaQuery';
import { PULL_THRESHOLD_PX, usePullToRefresh } from 'hooks/usePullToRefresh';
import * as S from './PullToRefresh.styles';

export default function PullToRefresh() {
  const { isNotDesktop } = useBreakpoints();
  const { pullDistance, isRefreshing } = usePullToRefresh(isNotDesktop);

  if (pullDistance === 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / PULL_THRESHOLD_PX, 1);

  return (
    <S.Indicator
      role="status"
      aria-label="Atualizar página"
      style={{
        transform: `translateY(${pullDistance - 36}px)`,
        opacity: progress,
      }}
    >
      <ReloadOutlined
        spin={isRefreshing}
        rotate={isRefreshing ? undefined : progress * 270}
      />
    </S.Indicator>
  );
}
